import { type ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "@/app/providers/useAuth";
import { chatService } from "@/features/settings/services/chat.service";
import { useChat } from "@/features/settings/viewModal/useChat";

export const useSettingsContactUsChatViewModel = () => {
  const { user } = useAuth();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [sessionId, setSessionId] = useState<string>("");
  const [expandedImage, setExpandedImage] = useState<string | null>(null);
  const {
    messages,
    textInputValue,
    imageUris,
    setTextInputValue,
    removeImage,
    onSend,
    handleAttachFiles,
    loading,
  } = useChat(sessionId);

  useEffect(() => {
    const initConversation = async () => {
      try {
        const conversation = await chatService.createConversation();
        setSessionId(String(conversation.id));
      } catch (error) {
        console.error("Failed to create conversation", error);
      }
    };
    void initConversation();
  }, []);

  const onFileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      handleAttachFiles(event.target.files);
      event.target.value = "";
    },
    [handleAttachFiles]
  );

  const isOwnMessage = useCallback(
    (senderId?: string): boolean => {
      const currentUserId = String(user?.id ?? "");
      return !!senderId && !!currentUserId && senderId === currentUserId;
    },
    [user?.id]
  );

  return {
    fileInputRef,
    sessionId,
    expandedImage,
    setExpandedImage,
    messages,
    textInputValue,
    imageUris,
    setTextInputValue,
    removeImage,
    onSend,
    onFileChange,
    loading,
    isOwnMessage,
  };
};
